import MainCard from "../../theme/mantis/components/mainCard";
import {
    Button,
    FormControl,
    FormHelperText,
    FormLabel,
    Grid,
    MenuItem,
    Select,
    Stack,
    Toolbar,
    Typography,
    useMediaQuery
} from "@mui/material";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {FormikProvider} from "formik";
import useCheckForm from "./useCheckForm";
import ContentLoader from "../../components/contentLoader/contentLoader";
import {PAGE_HOME} from "../../locales/pages/namespaces";
import axios from "axios";
import {enqueueSnackbar} from "notistack";
import {
    handleAxiosErrors,
    logoutUnauthorizedUser
} from "../../helpers/errorHandling";
import useUserData from "../../hooks/user/useUserData";
import useUserAction from "../../hooks/user/useUserAction";
import {API} from "../../helpers/constants";

const data = [
    {
        id: '0',
        label: 'Πιστοποιητικό βαθμολογίας φοιτητή',
        url: 'certificate/supplement/2/gr'
    },
    {
        id: '1',
        label: 'Παράρτημα Διπλώματος στην ελληνική γλώσσα (Diploma Supplement)',
        url: 'certificate/supplement/1/gr'
    },
    {
        id: '2',
        label: 'Παράρτημα Διπλώματος στην αγγλική γλώσσα (Diploma Supplement)',
        url: 'certificate/supplement/1/en'
    }
];

const data1 = [
    {
        id: '0',
        label: 'Πιστοποιητικό βαθμολογίας φοιτητή',
        url: 'certificate/supplement/2/gr'
    }
];

const data2 = [
    {
        id: '0',
        label: 'Πιστοποιητικό βαθμολογίας φοιτητή',
        url: 'certificate/supplement/2/gr'
    },
    {
        id: '1',
        label: 'Παράρτημα Διπλώματος στην ελληνική γλώσσα (Diploma Supplement)',
        url: 'certificate/supplement/1/gr'
    }
];

const RequestsForm = () => {
    const {t} = useTranslation(PAGE_HOME);

    /*
     * Ο production LoginController επιστρέφει:
     *
     * 'program' => $program
     * 'status'  => $stdStatus
     *
     * Επομένως εδώ χρησιμοποιούμε status και όχι std_status.
     */
    const {
        token,
        isLoggedIn,
        program,
        status
    } = useUserData();

    const {userLogout} = useUserAction();
    const [isLoading, setIsLoading] = useState(false);
    const {formik} = useCheckForm();
    const [pdf, setPdf] = useState('');

    const matchDownMD = useMediaQuery(
        (theme) => theme.breakpoints.down('md')
    );

    /*
     * Κανονικοποίηση των τιμών ώστε να μη δημιουργείται πρόβλημα
     * από κενά ή διαφορά πεζών/κεφαλαίων.
     */
    const normalizedStatus = String(status || '')
        .trim()
        .toLowerCase();

    const normalizedProgram = String(program || '')
        .trim()
        .toUpperCase();

    /*
     * Business logic:
     *
     * 1. Ο stu-apo βλέπει μόνο το πιστοποιητικό βαθμολογίας,
     *    ανεξάρτητα από το πρόγραμμα.
     *
     * 2. Για τον apo και για τα υπόλοιπα statuses παραμένει
     *    η προηγούμενη λογική επιλογών βάσει προγράμματος.
     */
    
	
	
	let requestOptions = [];

    if (normalizedStatus === 'stu-apo') {
        requestOptions = data1;
    } else if (
        normalizedProgram === 'ΤΛΧ' ||
        normalizedProgram === 'ΤΛΧΒ'
    ) {
        requestOptions = data1;
    } else if (
        normalizedProgram === 'ΕΠΟ' ||
        normalizedProgram === 'ΕΛΠ' ||
        normalizedProgram === 'ΔΕΟ' ||
        normalizedProgram === 'ΙΣΠ' ||
        normalizedProgram === 'ΠΛΗ' ||
        normalizedProgram === 'ΦΥΕ' ||
        normalizedProgram === 'ΔΗΔ' ||
        normalizedProgram === 'ΔΙΤ' ||
        normalizedProgram === 'ΣΚΙ'
    ) {
        requestOptions = data2;
    } else {
        requestOptions = data;
    }
	
	

    /*
     * Προσωρινά χρήσιμα για έλεγχο.
     * Μπορούν να αφαιρεθούν μετά την επιβεβαίωση στο production.
     */
    console.log('program raw:', program);
    console.log('program normalized:', normalizedProgram);
    console.log('status raw:', status);
    console.log('status normalized:', normalizedStatus);
    console.log('requestOptions:', requestOptions);

    const handleChange = (event) => {
        setPdf(event.target.value);
    };

    const handleSubmit = (requestedUrl) => {
        if (!requestedUrl) {
            return;
        }

        setIsLoading(true);

        axios({
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            url: `${API}/${requestedUrl}`,
            responseType: 'blob'
        })
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    {
                        type: 'application/pdf'
                    }
                );

                const url = window.URL.createObjectURL(blob);

                /*
                 * Δημιουργία προσωρινού link για download.
                 */
                const link = document.createElement('a');

                link.href = url;
                link.download = 'downloaded.pdf';
                link.style.display = 'none';

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                /*
                 * Άνοιγμα του PDF σε νέα καρτέλα.
                 */
                window.open(url, '_blank');

                /*
                 * Δεν αποδεσμεύουμε αμέσως το Blob URL,
                 * ώστε να προλάβει να το φορτώσει η νέα καρτέλα.
                 */
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                }, 1000);

                enqueueSnackbar(
                    t('Successfully downloaded PDF!'),
                    {
                        variant: 'success',
                        autoHideDuration: 1000
                    }
                );

                setPdf('');
                formik.resetForm();
            })
            .catch((error) => {
                enqueueSnackbar(
                    handleAxiosErrors(
                        error,
                        t('There is not a pdf to download!')
                    ),
                    {
                        variant: 'error'
                    }
                );

                logoutUnauthorizedUser(
                    error,
                    isLoggedIn,
                    userLogout
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return !isLoading ? (
        <FormikProvider value={formik}>
            <MainCard
                sx={
                    !matchDownMD
                        ? {
                            width: '70%',
                            ml: 10
                        }
                        : {
                            width: '100%'
                        }
                }
                title={
                    <Toolbar
                        disableGutters
                        variant="dense"
                    >
                        <Typography
                            variant="h4"
                            gutterBottom
                        >
                            {t('Requests')}
                        </Typography>
                    </Toolbar>
                }
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Stack spacing={0.5}>
                            <FormControl fullWidth>
                                <FormLabel htmlFor="request-select">
                                    {t('Choose a request')}
                                </FormLabel>

                                <Select
                                    labelId="request-select-label"
                                    id="request-select"
                                    value={pdf}
                                    onChange={handleChange}
                                >
                                    {requestOptions.map((item) => (
                                        <MenuItem
                                            value={item.id}
                                            key={item.id}
                                        >
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Stack
                            sx={{
                                width: '30%',
                                mt: 2.5
                            }}
                            spacing={0.5}
                        >
                            <Button
                                size="medium"
                                variant="contained"
                                disabled={pdf === ''}
                                sx={{
                                    float: 'right',
                                    mb: {
                                        xs: 1,
                                        md: 0
                                    },
                                    mt: 3
                                }}
                                onClick={() => {
                                    const selected = requestOptions.find(
                                        (item) => item.id === pdf
                                    );

                                    if (selected) {
                                        handleSubmit(selected.url);
                                    }
                                }}
                            >
                                {t('Submit')}
                            </Button>
                        </Stack>

                        <FormHelperText>
                            {t(
                                'Συνίσταται η εκτύπωση των εγγράφων σε έγχρωμη μορφή.'
                            )}
                        </FormHelperText>
                    </Grid>
                </Grid>
            </MainCard>
        </FormikProvider>
    ) : (
        <ContentLoader
            withBackDrop={true}
            useCircularLoader={true}
            loading={isLoading}
            message={t(
                "Loading... Please don't close the browser before the process ends."
            )}
        />
    );
};

export default RequestsForm;